import type {
  UniteHebergementDto,
  UniteHebergementPayloadDto,
} from "@vao/shared-bridge";

export interface UniteVisiteValue {
  id: number | null;
  visiteLocaux: boolean | null;
  visiteLocauxAt: string | null;
}

export interface TransportValue {
  vehiculesAdaptes: boolean | null;
  deplacementProximiteDescription: string;
  excursionDescription: string;
}

export interface VisiteTransportFormValues {
  unitesVisite: UniteVisiteValue[];
  transport: TransportValue;
}

export const emptyVisiteValue = (): UniteVisiteValue => ({
  id: null,
  visiteLocaux: null,
  visiteLocauxAt: null,
});

export const emptyTransportValue = (): TransportValue => ({
  vehiculesAdaptes: null,
  deplacementProximiteDescription: "",
  excursionDescription: "",
});

export const formatDateBack = (
  value: string | Date | null | undefined,
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateFront = (
  value: string | null | undefined,
): Date | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const mapUniteToVisiteValue = (
  unite: UniteHebergementDto,
): UniteVisiteValue => ({
  id: unite.id,
  visiteLocaux: unite.visiteLocaux ?? null,
  visiteLocauxAt: formatDateBack(unite.visiteLocauxAt),
});

export const buildVisiteValues = (
  unites: UniteHebergementDto[],
): UniteVisiteValue[] => unites.map(mapUniteToVisiteValue);

export type VisitePayload = Pick<
  UniteHebergementPayloadDto,
  "visiteLocaux" | "visiteLocauxAt"
>;

export const mapVisiteToUnitePayload = (
  visite: UniteVisiteValue,
): VisitePayload => ({
  visiteLocaux: visite.visiteLocaux ?? null,
  visiteLocauxAt: formatDateFront(visite.visiteLocauxAt),
});
